import { Component, type ErrorInfo, type ReactNode } from 'react';
import styles from './ErrorBoundary.module.css';

interface Props {
  readonly children: ReactNode;
}

interface State {
  readonly failed: boolean;
}

/**
 * Dernier filet : une exception dans un skin ne doit pas laisser une page
 * blanche. Le message reste dans le registre du site — pas de trace technique,
 * pas de nom de composant. La console garde le détail pour nous.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Steve a glissé :', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <div className={styles.fallback}>
        <p className={styles.line}>Steve a renversé quelque chose dans le bac.</p>
        <p className={styles.sub}>Steve knocked something over in the tank.</p>
        <button
          type="button"
          className={styles.retry}
          onClick={() => {
            window.location.reload();
          }}
        >
          remettre de l&apos;eau / refill the tank
        </button>
      </div>
    );
  }
}
